export const currencyFormat = (value: string | number, symbol: string = "") => {
  if (typeof value === "string") {
    if (value.includes("$")) {
      const newValue = value.split('$')[1]
      const valuesFixed = +newValue;
      const valueAfterFixed = valuesFixed.toFixed(2);

      let initialValue = valueAfterFixed
        .toString()
        .replace(/[^0-9,.]+/g, "")
        .split(".");
      let valuesWithComma = initialValue[0]
        .split(",")
        .join("")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      initialValue.splice(0, 1, valuesWithComma);
      return symbol
        ? `${symbol} ${initialValue.join(".")}`
        : `${initialValue.join(".")}`;
    } else {
      let initialValue = value
        .toString()
        .replace(/[^0-9,.]+/g, "")
        .split(".");
      let valuesWithComma = initialValue[0]
        .split(",")
        .join("")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      initialValue.splice(0, 1, valuesWithComma);
      return symbol
        ? `${symbol} ${initialValue.join(".")}`
        : `${initialValue.join(".")}`;
    }
  } else {
    return symbol
      ? `${symbol} ${value?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`.split(".")[0]
      : `${value?.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`.split(".")[0];
  }
};
